var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-page"},[_c('pro-form',_vm._b({ref:"formRef",on:{"submit":_vm.formSubmit,"reset":_vm.formReset}},'pro-form',_vm.newProFormProps,false)),_vm._t("addon"),_c('pro-table',_vm._g(_vm._b({ref:"tableRef",attrs:{"init-load":false}},'pro-table',_vm.newProTableProps,false),_vm.tableListeners))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }